// Code review - In Progress
// Documentation - In Progress
import { useState } from 'react';
import GridPage from '../components/GridPage'
import { companyDashboardHeader, companyPaymentDashboardHeader, SubmittedAssesmentDashboardHeader, vcpcompanyDashboardHeader, vcpDashboardHeader, vcpNotSubmittedDashboardHeader } from '../components/HeaderAttribute'
import { mainTable } from '../css/Common'
import * as XLSX from "sheetjs-style";

const DashboardPopup = ({ data, id, excelHeading }) => {


    const [showFileModal, setShowFileModal] = useState(false);

    const [selectedFileUrl, setSelectedFileUrl] = useState("");
    const handleExport = () => {

        const selectedHeader =
            [1].includes(id)
                ? companyDashboardHeader
                : id === 4
                    ? companyPaymentDashboardHeader :

                    id == 7 ? vcpcompanyDashboardHeader :
                        id == 9 ? vcpNotSubmittedDashboardHeader
                            : vcpDashboardHeader;

        exportData(
            selectedHeader.map(column => column.title),
            data
        );

    };

    const exportData = (columns, rows,) => {

        const titleRow = [
            {
                v: `${excelHeading}`,
                s: {
                    font: { bold: true, sz: 16 },
                    alignment: { horizontal: "left" },
                },
            },
        ];

        const headerRow = [
            ...columns.map((column) => ({
                v: column,
                s: {
                    fill: { fgColor: { rgb: "000000" } },
                    font: { bold: true, color: { rgb: "FFFFFF" } },
                    alignment: { horizontal: "left" },
                },
            })),

        ];


        let dataRows = rows.map((rowData, index) => {
            const isAlternateRow = index % 2 === 1;
            const baseStyle = isAlternateRow
                ? { fill: { fgColor: { rgb: "F0F0F0" } } }
                : {};

            const commonCells = [
                { v: index + 1, s: { ...baseStyle, alignment: { horizontal: "left" } } },
            ];

            if (id === 7) {
                // Insert after the first column (index)
                commonCells.splice(1, 0, {
                    v: rowData.Company,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                });
            }

            // Push the remaining columns
            commonCells.push(
                { v: rowData.PartnerName, s: { ...baseStyle, alignment: { horizontal: "left" } } },
                { v: rowData.PartnerEmailId, s: { ...baseStyle, alignment: { horizontal: "left" } } },
                { v: rowData.PartnerMobileNumber, s: { ...baseStyle, alignment: { horizontal: "left" } } },
                { v: rowData.ContactPersonName, s: { ...baseStyle, alignment: { horizontal: "left" } } },
                { v: rowData.Deadline, s: { ...baseStyle, alignment: { horizontal: "left" } } }
            );

            if (id === 4) {
                commonCells.push({
                    v: rowData.FeeDue,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                });
            }


            return commonCells;
        });

        const wsData = [
            titleRow,
            headerRow,
            ...dataRows,
        ];

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        ws["!cols"] = [
            { width: 8 }, // Index
            { width: 40 }, // Branch
            { width: 40 }, // IPC  No
            { width: 30 }, // IPC  No
            { width: 40 }, // IPC  No
            { width: 20 }, // IPC  No
            { width: 30 }, // IPC  No



        ];


        ws["!rows"] = [
            { hpt: 30 }, // Title row height
            { hpt: 15 }, // Date range row height
            { hpt: 15 }, // Branch row height (taller for wrapped content)
            { hpt: 15 }, // Spacing row height
            { hpt: 15 }, // Header row height (taller for wrapped content)
            ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
            { hpt: 15 }, // Totals row height
        ];

        // Apply borders and styles
        const applyStyles = (ws) => {
            const range = XLSX.utils.decode_range(ws["!ref"]);
            for (let R = range.s.r; R <= range.e.r; R++) {
                for (let C = range.s.c; C <= range.e.c; C++) {
                    const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                    if (!ws[cellRef]) continue;

                    // Add borders to all cells
                    ws[cellRef].s = {
                        ...ws[cellRef].s,
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };
                }
            }
        };

        applyStyles(ws);

        // Create and save workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `${excelHeading}.xlsx`);
    };

    const handleView = (rowIndex) => {
        var AttachmentFile = data[rowIndex].AttachmentFile;
        setSelectedFileUrl(AttachmentFile);
        setShowFileModal(true);
    };
    const isImageFile = (url) => {
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
        const ext = url?.split(".").pop()?.toLowerCase();
        return imageExtensions.includes(ext);
    };
    const getViewerUrl = (url) => {
        if (!url) return "";
        const extension = url.split(".").pop().toLowerCase();

        return extension === "pdf"
            ? url
            : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                url
            )}`;
    };
    return (
        <div class="w-full">
            <div class={mainTable.mainContentScreen}>
                <div class="p-2">
                    <GridPage

                        header={
                            [1].includes(id)
                                ? companyDashboardHeader || []
                                : id === 4
                                    ? companyPaymentDashboardHeader || []
                                    : id === 2 ? SubmittedAssesmentDashboardHeader || []
                                        : id === 7 ? vcpcompanyDashboardHeader || []
                                            : id === 9 ? vcpNotSubmittedDashboardHeader || []
                                                : vcpDashboardHeader || []
                        }

                        records={data}
                        xlExportView={true}
                        addView={true}
                        handleExport={handleExport}
                        handleSchoolView={handleView}
                        tableHeight="h-60 overflow-y-auto"
                    />
                </div>
            </div>
            {showFileModal && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={() => setShowFileModal(false)} // Outside click closes modal
                >
                    <div
                        className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
                        onClick={(e) => e.stopPropagation()} // Prevent close on inside click
                    >
                        <button
                            onClick={() => setShowFileModal(false)}
                            className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
                        >
                            ✕
                        </button>
                        {selectedFileUrl ? (
                            isImageFile(selectedFileUrl) ? (
                                <img
                                    src={selectedFileUrl}
                                    alt="Preview"
                                    className="w-full h-full object-contain rounded"
                                />
                            ) : (
                                <iframe
                                    src={getViewerUrl(selectedFileUrl)}
                                    title="File Viewer"
                                    className="w-full h-[80vh] rounded"
                                />
                            )
                        ) : (
                            <div className="text-center text-gray-500">No file selected</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default DashboardPopup